import {Avatar, Button, Checkbox, Input, Modal, Switch} from 'antd'
import {course_getCourseClassesAvailForStudent_Api, medal_addMedalAward_Api,} from 'apis'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import {showConfirm} from 'components/Feed/TimeLineFeed'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik, FormikConsumer} from 'formik'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {RiMapPinFill, RiSearchEyeLine, RiSubscript} from 'react-icons/ri'
import {TbCertificate, TbCertificateOff, TbSum} from 'react-icons/tb'
import {compose, mapProps, pure} from 'recompose'
import {AppEntities} from 'views/AppLocals/enums'
import {NullAsDefault, pagerControls} from 'views/Shared'
import {StudentActionTypes} from '..'
import {
    course_assignMultiStudentToCourse_Api,
    course_assignStudentToCourse_Api,
    course_editStudentFromCourse_Api,
    course_getCourseById_Api,
    course_getCourseStudents_Api,
    course_revokeCertificateFromStudent_Api,
    course_revokeStudentFromCourse_Api
} from '../../../../apis'
import DynamicFieldsUtilization from '../../../../components/DynamicFields/DynamicFieldUtilization'
import {createSelectValue, createValue} from '../../../../components/form/utils'
import HeaderGroupItem from '../../../../components/ItemLayout/HeaderGroupItem'
import {FullSideModalLayout} from '../../../../components/Modal/SideModalLayout'
import {createModalTitle} from '../../../../components/renderFunctions/createModalTitle'
import {renderIf, renderIfElse, renderSelf, shallowDiff} from '../../../Shared'
import EntityList, {NoneStickyMeta} from '../../EntityList'
import {showDeleteConfirmDialog} from '../../factory/createConfirmDialog'
import createContextMenu from '../../factory/createContextMenu'
import {notifyOnError} from '../../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {bindQueryParam, bindQueryParams} from '../../functions/routerHelper'
import {HeaderWithIconLine, ListHeaderLineAndDes} from '../../Templates/items/ListHeader'
import {CourseClassSelector} from '../components/CourseClassSelector'
import {StudentSelector} from '../components/StudentSelector'
import {createControlledFormField} from "../../factory/createFormField";
import LookupField from "../../../../components/LookupField";
import FieldDecorator from "../../../../components/form/FieldDecorator";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {MdChurch} from "react-icons/md";
import {renderCourseStudent} from "../../../Workspace/Course/functions/renderCourseStudent";
import {StudentInformationFull} from "../Student/components/StudentInformationFull";
import CourseStudentSubjectResults from "./CourseStudentSubjectResults";
import getTitle from "../../../../helpers/getTitle";
import {BsCaretRightFill, BsInfoCircleFill} from "react-icons/bs";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {renderMetadata} from "../../../../components/DynamicFields/functions/renderMetadata";
import {GiPlainCircle} from "react-icons/gi";
import Async from "../../../../modules/asyncCache/components/Async";
import WorkspaceContext from "../../../Workspace/WorkspaceContext";
import Pure from "../../../../components/Pure";
import {FaUserGraduate} from "react-icons/fa6";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {renderEmptyHolderMember} from "../../CatholicHousehold/functions/renderEmptyHolderMember";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import withTranslate from "../../../../modules/local/withTranslate";
import {PiCertificate} from "react-icons/pi";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import LoadingBlock from "../../../LoadingBlock";

const StudentSelection = ({form, name, value, course, defaultValue = [], handleChange = NullAsDefault, ...props}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const students = value || defaultValue;
    const {organization} = useContext(WorkspaceContext)

    return (
        <div className="flex flex-col gap-3">
            <div className="flex">
                <LookupField
                    cacheRequired={false}
                    title={t('select student')}
                    createIfNotExists={true}
                    placeholder={t('click to select / create')}
                    apiPath={`/lookup/student/get-by-types?owner_type=organization&owner_id=${organization?.id}&not_course_id=${course?.id}`}
                    OptionWrapper={({children, ...props}) =>
                        <div
                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                            {children}
                        </div>
                    }
                    handleChange={(e) => {
                        let _students = _.cloneDeep(students);

                        const student = _.find(_students, {id: e.target.id});
                        if (!student) {
                            _students.push({
                                student: e.target,
                                student_name: e.target.value,
                                student_id: e.target.id,
                                id: e.target.id || e.target.value,
                            });
                            handleChange(_students)
                        }
                    }}
                    renderOption={(o, i) => {
                        return (
                            <div key={i} className="flex items-center flex-1 gap-3">
                                {renderIf(
                                    !isSm,
                                    <Avatar
                                        size={50}
                                        src={o.avatar}
                                        className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                        icon={<FaUserGraduate size={20} style={{color: '#dddddd'}}/>}
                                    />
                                )}
                                <div className="flex flex-col">
                                        <span className="font-bold text-color-000 leading-snug">
                                            {o?.patron_saint_name || o?.patron_saint?.name} {o?.fullname}
                                        </span>
                                    <ItemInformation label="student code" value={_.get(o, 'student_idcode')}
                                                     className="text-2xs italic"/>
                                </div>
                            </div>
                        )
                    }}
                />
            </div>
            {students.map((std, idx) => {
                const {student, student_name} = std ?? {}
                return (
                    <div key={idx} className="py-2 rounded-md custom-item-render custom-render-border relative">

                        {
                            student ? (
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={30}
                                        src={student.avatar}
                                        icon={<FaUserGraduate size={16} className="text-color-500"/>}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col flex-1">
                                        <Link to={getLinkToDetail(student)}
                                              className="font-bold text-color-000 no-underline leading-snug">
                                            {student?.prefix_title || student?.patron_saint_name || ''} {getTitle(student)}
                                        </Link>
                                        <ItemInformation label="student code" value={_.get(student, 'student_idcode')}
                                                         className="text-2xs italic"/>
                                    </div>
                                </div>) : (
                                <div className="font-bold text-color-000">
                                    {student_name}
                                </div>
                            )}
                        <BiTrash
                            onClick={() => {
                                let _students = _.cloneDeep(students);
                                showDeleteConfirmDialog({
                                    translate: t,
                                    title: 'delete student',
                                    message: 'are you sure you want to delete this student',
                                    onOk: () => {
                                        _.remove(_students, {id: student?.id});
                                        handleChange(_students)
                                    },
                                })
                            }}
                            className="absolute top-5 right-5 contextIcon text-primary-200 hover:text-primary cursor-pointer"
                        />
                    </div>
                )
            })}

        </div>
    )
}


const formSchema = {
    student: {
        title: 'student',
        children: [
            {
                name: 'student',
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(StudentSelector),
            },
        ],
    },
    course_class: {
        title: 'transfer to class',
        children: [
            {
                name: 'course_class',
                component: mapProps(({name, value, form, onChange}) => {
                    const {course_id, student_id} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        course_id,
                        customConfigs: {
                            apiInfo: course_getCourseClassesAvailForStudent_Api,
                            query: bindQueryParams([{student_id}, {id: course_id}]),
                        },
                    }
                })(CourseClassSelector),
            },
        ],
    },
    select_class_in_course: {
        title: 'choose classes',
        children: [
            {
                name: 'course_class_id',
                component: compose(
                    withTranslate,
                    mapProps(({name, translate, onChange, value, form, ...restForm}) => {

                        const options = form?.values?.course_classes?.map(e => {
                            return {value: e.id, label: `${e?.title} (${e?.student_count} ${translate('students')})`}
                        })
                        return {
                            name,
                            allowClear: true,
                            className: 'w-full',
                            value: value || undefined,
                            onChange: (value) => {
                                onChange(createSelectValue('course_class_id', value))
                            },
                            placeholder: translate('---Choose One---'),
                            options: options,
                        }
                    }),
                    pure
                )(SelectWidget),
            },
        ],
    },
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    rows: 3,
                    className: 'w-full',
                    placeholder: 'notes',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    information_group_header: {
        children: [
            {
                component: () => <HeaderGroupItem title="manager information"/>,
            },
        ],
    },
    metadata: {
        children: [
            {
                name: 'metadata',
                component: ({name, value, onChange}) => (
                    <DynamicFieldsUtilization
                        name={name}
                        value={value}
                        className="w-full"
                        onChange={(value) => {
                            onChange(createValue(name, value ?? null))
                        }}
                    />
                ),
            },
        ],
    },
    diocese_location: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose parish')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.parish_name}
                                    selectedOption={form?.values?.parish}
                                    placeholder={t('click to select / create')}
                                    apiPath={`/lookup/parish/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        const {fullname, diocese_fullname, location_address} = o ?? {}
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={50}
                                                    src={o.avatar}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                />
                                                <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                                                    <div className="space-x-1 leading-snug">
                                                        <span
                                                            className="font-bold text-sm text-color-000">{fullname}</span>
                                                        <span
                                                            className="font-medium text-xs text-blue-500 italic leading-snug">{`( ${diocese_fullname} )`}</span>
                                                    </div>
                                                    {renderIf(
                                                        location_address,
                                                        <div className="flex items-center gap-x-1">
                                                            <RiMapPinFill size={11} className="text-color-400"/>
                                                            <span
                                                                className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">{location_address}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            parish: e.target,
                                            parish_name: e.target.value,
                                            parish_id: e.target.id,
                                            diocese: e.target.diocese,
                                            diocese_name: e.target?.diocese?.name,
                                            diocese_id: e.target?.diocese?.id
                                        });
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'diocese',
                name: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.diocese_name}
                                            selectedOption={form?.values?.diocese}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={50}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target?.value,
                                                    diocese_id: e.target?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },

    students_selection: {
        title: 'students',
        children: [
            {
                name: 'students',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: StudentSelection,
                    withForm: ({...props}) => ({form: {...props}}),
                    withProps: ({name, value, onChange, ...props}) => ({
                        defaultValue: value,
                        handleChange: (_value) => {
                            onChange(createValue(name, _value))
                        },
                        ...props
                    }),
                    withValues: ({resetKey, course}) => ({
                        resetKey, course
                    }),
                }),
            },
        ],
    },

    payment_status: {
        label: 'payment status',
        children: [
            {
                name: 'payment_status',
                className: 'w-full flex flex-col',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate: t}) => ({
                        name,
                        checked: !!value,
                        style: {width: 'auto'},
                        checkedChildren: t('yes'),
                        // unCheckedChildren: t('no'),
                        className: 'w-fit',
                        onChange: (value) => {
                            onChange(createValue(name, Number(value ?? 0)))
                        },
                    }))
                )(Switch),
            },
        ],
    },
}

export const CourseStudentAssignmentModal = ({
                                                 course = {},
                                                 owner_id,
                                                 owner_type,
                                                 onSubmit = NullAsDefault,
                                             }) => {
    const t = useTranslate();

    const initialValues = useMemo(
        () => ({
            owner_id,
            owner_type,
            students: [],
            course,
            course_classes: course?.course_classes || []
        }),
        [owner_id, owner_type, course]
    )

    const validate = (values) => {
        let errors = {}

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {students, course_class_id} = values ?? {}
                const ids = students.map(item => item.student_id);

                onSubmit({
                    student_ids: ids,
                    course_class_id
                })
            }}>
            <ActionModalWrapper action={<FormActionBar submitText="enroll"/>}>
                <div className="text-color-400 italic">
                    {`* ${t('assign student for course description')}`}
                </div>
                <FieldsFactory
                    formSchema={[
                        formSchema.students_selection,
                        formSchema.select_class_in_course,
                    ]}
                />
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseStudentUpdateModal = ({
                                             item,
                                             course,
                                             courseStudent,
                                             onSubmit = NullAsDefault,
                                             source = null
                                         }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview');

    const initialValues = useMemo(() => ({
            notes: courseStudent?.notes ?? null,
            course: courseStudent?.course ?? {},
            metadata: courseStudent?.metadata ?? [],

            payment_status: courseStudent?.payment_status ?? null,

            diocese_id: _.get(courseStudent, 'diocese.id', ''),
            diocese_name: _.get(courseStudent, 'diocese.name', ''),
            diocese: _.get(courseStudent, 'diocese', ''),

            parish_id: _.get(courseStudent, 'parish.id', ''),
            parish_name: _.get(courseStudent, 'parish.name', ''),
            parish: _.get(courseStudent, 'parish', ''),

            subject_ids: _.get(courseStudent, 'registered_subjects', []).map(e => {
                return e?.id;
            })
        }),
        []
    );

    const validate = (values) => {
        let errors = {}

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            // enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={({metadata, subject_ids, diocese, parish, ...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(
                    _.omitBy(
                        {
                            ...(changes ?? {}),
                            metadata: JSON.stringify(metadata),
                            subject_ids: subject_ids ? subject_ids.join(",") : undefined
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                tab={current}
                action={<FormActionBar submitText="save"/>}
                onTabChange={(key) => {
                    setCurrent(key)
                }}
                tabs={[
                    {
                        key: 'overview',
                        label: 'overview',
                        component: () => (
                            <StudentInformationFull {...courseStudent}/>
                        )
                    },
                    {
                        key: 'additional_info',
                        label: 'manage course information',
                        component: () => (
                            <React.Fragment>
                                <div className="text-color-400 italic">
                                    {`* ${t('update student information in the class description')}`}
                                </div>
                                <Pure>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.diocese_location,
                                            formSchema.payment_status,
                                            formSchema.notes,
                                            formSchema.metadata,
                                        ]}
                                    />
                                </Pure>
                                <FormikConsumer>
                                    {({values, errors, handleChange}) => {
                                        return (
                                            <div className="flex flex-col gap-2 pt-3">
                                                <ListHeaderLineAndDes
                                                    renderTitle={() => (
                                                        <div className="flex items-start gap-1">
                                                            <BsCaretRightFill size={15}
                                                                              className="text-color-500 mr-1"/>
                                                            <div
                                                                className="flex-1 font-bold text-base text-color-300 uppercase tracking-wide leading-tight">
                                                                {t('subjects')}
                                                            </div>
                                                        </div>
                                                    )}
                                                    description="with subject"

                                                />
                                                <FieldDecorator
                                                    key="subject_ids"
                                                    errors={errors["subject_ids"]}
                                                >
                                                    <Checkbox.Group
                                                        className="grid grid-cols-2 gap-2"
                                                        name="subject_ids"
                                                        options={_.get(course, 'subjects', []).map(e => {
                                                            return {
                                                                value: e?.subject?.id,
                                                                label: e?.subject?.title
                                                            }
                                                        })}
                                                        defaultValue={values.subject_ids}
                                                        onChange={e => {
                                                            handleChange(createValue('subject_ids', e))
                                                        }}
                                                    />
                                                </FieldDecorator>
                                            </div>
                                        )
                                    }}
                                </FormikConsumer>
                            </React.Fragment>
                        ),
                    },
                ]}>
            </ActionModalWrapper>
        </Formik>
    )

}

export const CourseStudentDetail = ({item}) => {
    const t = useTranslate()
    const {metadata = [], registered_subjects = []} = item ?? {}

    return (
        <div className="flex flex-col gap-6">
            <StudentInformationFull {...item}/>
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    renderTitle={() => (
                        <div className="flex items-center gap-2">
                            <RiSubscript size={14} className="text-color-500"/>
                            <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                                {t('subjects registered')}
                            </span>
                        </div>
                    )}
                />
                {renderIfElse(
                    registered_subjects.length > 0,
                    <div className="ml-2 md:ml-3 grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
                        {registered_subjects.map((e, i) => (
                            <span key={i} className="flex items-center gap-x-2">
                                <GiPlainCircle size={7} className="text-blue-200"/>
                                <span className="font-semibold text-blue-600 text-sm italic leading-snug">
                                    {getTitle(e)}
                                </span>
                            </span>
                        ))}
                    </div>,
                    renderEmptyHolderMember("no data is available now", "the student has not registered for the course")
                )}
            </div>
            {renderIf(
                metadata.length > 0,
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        renderTitle={() => (
                            <div className="flex items-center gap-2">
                                <BsInfoCircleFill size={14} className="text-color-500"/>
                                <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                                    {t('additional information')}
                                </span>
                            </div>
                        )}
                    />
                    <div className="ml-2 md:ml-3">
                        {renderMetadata(metadata, false, 'text-xs')}
                    </div>
                </div>
            )}
            <div className="h-1"/>
        </div>
    )
}

export const CourseStudents = ({
                                   item,
                                   header = null,
                                   controls = pagerControls,
                                   renderFooter = renderSelf,
                                   container_type = AppEntities.COURSE,
                               }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const course = item

    const [refreshToken, setRefreshToken] = useState()

    const {owner, subjects = [], academic_year, course_classes = [], time_open, time_close, last_enrollment_time} = item ?? {}

    const [owner_id, owner_type] = [getId(owner), getType(owner)]

    const {keyword, component: search_widget} = controls?.search ?? {}
    const [course_class_id, setCourseClassId] = useState()
    const [viewMode, setViewMode] = useState("normal")
    const [filteredSubject, setFilteredSubject] = useState(null)

    const apiInfo = course_getCourseStudents_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo?.path.replace(':id', course?.id),
                JSON.stringify(keyword),
                course_class_id,
                refreshToken,
                filteredSubject?.id
            ].join(','),
        [keyword, refreshToken, course_class_id, filteredSubject]
    )

    const onError = notifyOnError(t)

    const onCancel = () => {
        setAction({})
    }

    const reload = () => {
        setRefreshToken(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onAssign} = useAsyncAction({
        apiInfo: course_assignStudentToCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onAssignMulti} = useAsyncAction({
        apiInfo: course_assignMultiStudentToCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: course_editStudentFromCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onRevoke} = useAsyncAction({
        apiInfo: course_revokeStudentFromCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onAwardMedal} = useAsyncAction({
        apiInfo: medal_addMedalAward_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })
    const {handleAsyncAction: onRevokeMedal} = useAsyncAction({
        apiInfo: course_revokeCertificateFromStudent_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const handleAction = (action, params) => {
        const id = params?.id
        switch (action) {
            case StudentActionTypes.STUDENT_DETAIL:
            case StudentActionTypes.STUDENT_ASSIGN:
            case StudentActionTypes.STUDENT_IN_COURSE_UPDATE:
            case StudentActionTypes.STUDENT_SUBJECT_SCORE_SUMMARY:
                setAction({type: action, value: params})
                break
            case StudentActionTypes.STUDENT_REVOKE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'revoke student',
                        message: 'are you sure you want to revoke this student',
                        onOk: () => {
                            onRevoke({}, {id})
                        },
                    })
                }
                break
            case StudentActionTypes.STUDENT_AWARDING_MEDAL:
                if (id) {
                    const {student} = params ?? {}
                    const ref_id = getId(course)
                    const ref_type = getType(course)
                    showConfirm({
                        icon: (
                            <TbCertificate
                                style={{color: '#48bb78'}}
                                className="anticon"
                            />
                        ),
                        className: 'custom-modal',
                        title: (
                            <span className="font-bold text-green-600">
                {t('award certificate')}
              </span>
                        ),
                        content: (
                            <span className="text-sm text-color-500 italic">
                {t(
                    'are you sure you want to award certification to this student'
                )}
              </span>
                        ),
                        okText: t('sure'),
                        cancelText: t('ignore'),
                        okButtonProps: {
                            type: 'primary',
                            className: 'button-rounded-lg no-border',
                        },
                        cancelButtonProps: {
                            className: 'button-rounded-lg no-border',
                        },
                        onOk: () => {
                            onAwardMedal(
                                {
                                    ref_id,
                                    ref_type,
                                },
                                {
                                    id: getId(student),
                                    prop: getType(student),
                                    medal_id: getId(course?.medal),
                                }
                            )
                        },
                    })
                }
                break

            case StudentActionTypes.STUDENT_REVOKE_MEDAL:
                if (id) {
                    const {student} = params ?? {}
                    const ref_id = getId(course)
                    const ref_type = getType(course)
                    showConfirm({
                        icon: (
                            <TbCertificateOff
                                style={{color: '#48bb78'}}
                                className="anticon"
                            />
                        ),
                        className: 'custom-modal',
                        title: (
                            <span className="font-bold text-green-600">
                {t('revoke certificate')}
              </span>
                        ),
                        content: (
                            <span className="text-sm text-color-500 italic">
                {t(
                    'are you sure'
                )}
              </span>
                        ),
                        okText: t('sure'),
                        cancelText: t('ignore'),
                        okButtonProps: {
                            type: 'primary',
                            className: 'button-rounded-lg no-border',
                        },
                        cancelButtonProps: {
                            className: 'button-rounded-lg no-border',
                        },
                        onOk: () => {
                            onRevokeMedal(
                                {},
                                {
                                    id: course?.id,
                                    student_id: getId(student)
                                }
                            )
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-color-400"/>,
                        label: 'view detail',
                        key: StudentActionTypes.STUDENT_DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'update info in course',
                        key: StudentActionTypes.STUDENT_IN_COURSE_UPDATE,
                    },
                    {
                        icon: <TbSum size={14} className="text-primary"/>,
                        label: 'academic results',
                        key: StudentActionTypes.STUDENT_SUBJECT_SCORE_SUMMARY,
                    },
                    {
                        icon: <PiCertificate size={14} className="text-green-500"/>,
                        label: 'certification',
                        children: [
                            {
                                icon: <TbCertificate size={14} className="text-green-600"/>,
                                label: 'award certificate',
                                disabled: !!item?.medal_awards?.length || !course?.medal,
                                key: StudentActionTypes.STUDENT_AWARDING_MEDAL,
                            },
                            {
                                icon: <TbCertificateOff size={14} className="text-red-600"/>,
                                label: 'revoke certificate',
                                disabled: !!!item?.medal_awards?.length,
                                key: StudentActionTypes.STUDENT_REVOKE_MEDAL,
                            },
                        ],
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: StudentActionTypes.STUDENT_REVOKE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        [course]
    )

    const modal = useMemo(() => {
        let title
        let Content = NullAsDefault
        let params = {title: undefined}
        let modal_params = {}
        let Wrapper = ({children}) => children({item: {}})

        switch (action?.type) {
            case StudentActionTypes.STUDENT_SUBJECT_SCORE_SUMMARY:
                if (container_type === AppEntities.COURSE) {
                    title = (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('academic results')}
                        </div>
                    )
                    params = {
                        onCancel,
                        course: item,
                        student: action?.value?.student,
                        course_student: action?.value,
                    }
                    modal_params = {
                        width: 640,
                    }
                    Content = CourseStudentSubjectResults
                    break
                } else {
                    return (
                        <FullSideModalLayout
                            right={true}
                            onCancel={onCancel}
                            title={createModalTitle('academic results')}>
                            <CourseStudentSubjectResults
                                course={item}
                                student={action?.value?.student}
                                course_student={action?.value}
                            />
                        </FullSideModalLayout>
                    )
                }
            case StudentActionTypes.STUDENT_IN_COURSE_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('update info in course')}
                    </div>
                )
                params = {
                    item: action?.value,
                    courseStudent: action?.value,
                    source: 'CourseStudentForm',
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {
                            id: action?.value?.id,
                        })
                    },
                }
                modal_params = {
                    width: 768,
                }
                Content = ({...rest}) => (
                    <Async
                        {...{
                            apiInfo: course_getCourseById_Api,
                            query: {':id': course?.id}
                        }}>
                        {
                            (data) => {
                                const dataItem = _.get(data, 'response.data', course)
                                return (
                                    <CourseStudentUpdateModal
                                        {...rest}
                                        course={dataItem}
                                    />
                                )
                            }
                        }
                    </Async>
                )
                break
            case StudentActionTypes.STUDENT_ASSIGN:
                title = (
                    <div className="uppercase text-center font-bold text-color-000">
                        {t('assign course student')}
                    </div>
                )
                params = {
                    course,
                    onCancel,
                    onSubmit: (values) => {
                        const {...rest} = values ?? {}
                        onAssignMulti(
                            {...rest},
                            {
                                course_id: course?.id,
                            }
                        )
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = ({...rest}) => (
                    <Async
                        {...{
                            apiInfo: course_getCourseById_Api,
                            query: {':id': course?.id}
                        }}>
                        {
                            (data) => {
                                const dataItem = _.get(data, 'response.data', course)
                                return (
                                    <CourseStudentAssignmentModal
                                        {...rest}
                                        course={dataItem}
                                    />
                                )
                            }
                        }
                    </Async>
                )
                break
            case StudentActionTypes.STUDENT_DETAIL:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide  111-111-111">
                        {t('student information')}
                    </div>
                )
                params = {
                    item: action?.value
                }
                modal_params = {
                    width: 640,
                }
                Content = CourseStudentDetail
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock    />
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type, course_class_id])

    return (
        <ActionModalWrapper className="flex-1">
            {header}

            {/*

            <div className="flex flex-col gap-1 mb-3">
                <HeaderWithIconLine
                    renderTitle={() => (
                        <div className="flex items-center gap-2">
                            <BsInfoCircleFill size={14} className="text-color-500"/>
                            <span className="font-bold text-sm text-color-400 uppercase tracking-wider">
                                {t('course information')}
                            </span>
                        </div>
                    )}
                />
                <div className="ml-3 flex flex-col gap-1">
                    <ItemInformation showIcon={true} label="academic year" value={academic_year}
                                     className="text-xs italic"/>
                    <DoubleValueItem
                        showIcon={true}
                        labelFirst="time"
                        valueFirst={formatDate(time_open,'DD/MM/YYYY')}
                        labelSecond={time_close ? ' - ' : ''}
                        valueSecond={time_close && formatDate(time_close,'DD/MM/YYYY')}
                        className="text-xs italic"
                    />
                    {renderIf(
                        last_enrollment_time,
                        <ItemInformation showIcon={true} label="last enrollment time"
                                         value={formatDate(last_enrollment_time,'DD/MM/YYYY')}
                                         className="text-xs italic"/>
                    )}
                    <ItemInformation showIcon={true} label="number of class"
                                     value={`${course_classes.length} ${t('class')}`} className="text-xs italic"/>
                    <ItemInformation showIcon={true} label="number of subject" value={subjects.length}
                                     className="text-xs italic"/>
                </div>
            </div>
            */}

            <EntityList
                cacheId={refreshKey}
                key={refreshKey}
                apiInfo={apiInfo}
                values={{keyword, course_class_id, subject_id: filteredSubject?.id}}
                RenderEntity={React.Fragment}
                PaginationMeta={NoneStickyMeta}
                query={bindQueryParam({id: course?.id})}
                renderItem={renderCourseStudent({renderContextMenu})}
                renderWrap={(children, __, count) => (
                    <div className="flex flex-col gap-4 flex-1">
                        <HeaderWithIconLine
                            renderTitle={() => (
                                <div className="flex items-center gap-3">
                                    <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                                        {t('list of students')}
                                    </span>
                                    {/*<span className="font-bold text-2xs text-blue-500 italic">{`( ${count} )`}</span>*/}
                                </div>
                            )}
                            extra={
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        handleAction(StudentActionTypes.STUDENT_ASSIGN)
                                    }}
                                    style={{height: 26}}
                                    className="flex flex-center button-rounded-md no-border font-medium text-xs leading-tight px-2 md:px-4">
                                    {t(isSm ? 'add student' : 'add student to course')}
                                </Button>
                            }
                        />
                        <div className="flex gap-1">
                            <span style={{marginTop: 2}}
                                  className="text-xs text-color-400 italic whitespace-no-wrap leading-snug">
                                {`${t('view for subject')} : `}
                            </span>
                            <div className="flex flex-wrap gap-y-1 gap-x-2">
                                {subjects.map((e, i) => (
                                    <span
                                        key={i}
                                        style={{padding: '0px 8px', height: 24, borderRadius: 4}}
                                        onClick={() => {
                                            if (filteredSubject?.id === e?.subject?.id) {
                                                setFilteredSubject(null)
                                            } else {
                                                setFilteredSubject(e?.subject)
                                            }
                                        }}
                                        className={classNames(
                                            "flex flex-center font-semibold text-xs leading-snug cursor-pointer",
                                            filteredSubject === e ? "bg-blue-100 hover:bg-blue-200 text-blue-600" :
                                                "background-200 hover:bg-blue-50 text-color-300 hover:text-blue-500"
                                        )}>
                                            {getTitle(e.subject)}
                                        </span>
                                ))}
                            </div>
                        </div>
                        {search_widget}
                        {children}
                    </div>
                )}
            />
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}

export const CourseStudentsSearchBinding = (props) => bindingSearch(props)(CourseStudents)



